export default __webpack_public_path__ + "static/media/Billi.1e70b560.png";